export const filterRecords = (data, filter) => {
  console.log('data, filter: ', data, filter);
  let filteredData = [];
  filteredData = data.filter((item) => {
    let filtersData = filter.map((items) => {
      let columnData = item[items.key.id];
      let conditionType = items.condition.key;
      if (items.key.type === 'number') {
        let value = items.value !== null ? items.value : 0;
        switch (conditionType) {
          case 'greater':
            return columnData > parseFloat(value);
          case 'less':
            return columnData < parseFloat(value);
          case 'equal':
            return columnData === parseFloat(value);
        }
      }
      else if (items.key.type === 'string') {
        columnData = (item[items.key.id] !== null && item[items.key.id] !== undefined) ? item[items.key.id].toLowerCase() : '';
        let value = (items.value !== null && items.value !== undefined) ? items.value : '';
        switch (conditionType) {
          case 'equal':
            return columnData === value.toLowerCase();
          case 'contains':
            return columnData.includes(value.toLowerCase());
        }
      } else {
        columnData = (item[items.key.id] !== null && item[items.key.id] !== undefined) ? item[items.key.id] : '';
        let value = items.value !== null ? items.value : '';
        if (columnData !== '') {
          let time1 = new Date(columnData)
          let time2 = new Date(value);
          let month1 = time1.getMonth() + 1;
          let date1 = time1.getDate();
          let year1 = time1.getFullYear();
          let month2 = time2.getMonth() + 1;
          let date2 = time2.getDate();
          let year2 = time2.getFullYear();
          switch (conditionType) {
            case 'greater':
              return (year1 > year2) || (year1 === year2 && month1 > month2) || (year1 === year2 && month1 === month2 && date1 > date2);
            case 'less':
              return (year1 < year2) || (year1 === year2 && month1 < month2) || (year1 === year2 && month1 === month2 && date1 < date2);
            case 'equal':
              return date1 === date2 && month1 === month2 && year1 === year2;
          }
        }
      }
    });
    let isTrue = filtersData.some((item) => {
      return item === false
    })
    if (!isTrue) {
      return item;
    }
  });
  return filteredData;
}

export const filterDeviceCatalogueData = (data) => {
  let items = [];
  data.map((n, index) => {
    const status = n && n.status;
    const temperature1 = n.data && n.data.sensors && n.data.sensors.temperature1;
    const temperature2 = n.data && n.data.sensors && n.data.sensors.temperature2;
    const temperature3 = n.data && n.data.sensors && n.data.sensors.temperature3;
    const current1 = n.data && n.data.sensors && n.data.sensors.current1;
    const current2 = n.data && n.data.sensors && n.data.sensors.current2;
    const water = n.data && n.data.sensors && n.data.sensors.water;
    const lid = n.data && n.data.notification && n.data.notification.eventVal;
    console.log('n.data.sensors.time: ', n.data.sensors);
    const time = n.data && n.data.sensors && this.formatDate(n.data.sensors.time);
    let currentThreshold1 = n.data && n.data.thresholds && n.data.thresholds.current1;
    let currentThreshold2 = n.data && n.data.thresholds && n.data.thresholds.current2;
    items.push({
      id: index,
      nodeId: n.nodeId,
      time,
      status,
      temperature1,
      temperature2,
      temperature3,
      current1,
      current2,
      water,
      lid,
      n,
      currentThreshold1,
      currentThreshold2
    })
  })
  return items;
}


// WEBPACK FOOTER //
// ./app/routes/filterModal/filterFunction.js